import type { RouteLocationNormalizedGeneric } from '#vue-router'

import { useMiddlewareSurveysQuery } from '@composables/middleware/surveys-query.hook'

import { defineNuxtRouteMiddleware } from '#app'

/** `/surveys` — every discipline's surveys. */
export default defineNuxtRouteMiddleware((to: RouteLocationNormalizedGeneric) => useMiddlewareSurveysQuery(to, null))
